import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { sendOTP } from "../../../actions";
import { AuthInput } from "../../../src-new/components/inputs/AuthInput";

const ResetForm = (props) => {
  const { dark } = props;
  const dispatch = useDispatch();
  const [emailAddress, setEmailAddress] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const emailHandler = (e) => {
    setEmailAddress(e.target.value);
    setEmailError("");
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (!emailAddress.trim()) {
      setEmailError("Email is required");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailAddress.trim())) {
      setEmailError("Please enter a valid email address");
      return;
    }
    setIsSubmitting(true);
    props.setMail(emailAddress);
    dispatch(sendOTP(
      emailAddress,
      () => { props.setCheck(true); },
      () => { setIsSubmitting(false); setEmailError("No account found with this email address"); }
    ));
  };

  return (
    <>
      <div className="mb-7 text-center">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full mb-4" style={dark ? { background: 'rgba(99,102,241,0.2)' } : { background: '#eff6ff' }}>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={dark ? { color: 'rgba(165,180,252,0.9)' } : { color: '#2563eb' }}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
          </svg>
        </div>
        <h1 className="text-2xl font-semibold mb-1.5" style={dark ? { color: 'rgba(255,255,255,0.95)' } : { color: '#111827' }}>Reset your password</h1>
        <p className="text-sm" style={dark ? { color: 'rgba(255,255,255,0.5)' } : { color: '#6b7280' }}>Enter your email and we'll send you a verification code</p>
      </div>

      <form onSubmit={submitHandler} noValidate>
        <AuthInput dark={dark} label="Email address" name="email" value={emailAddress} onChange={emailHandler} placeholder="you@company.com" error={emailError} />

        <button
          type="submit"
          disabled={isSubmitting}
          className={`mt-6 w-full py-2.5 px-4 text-white text-sm font-semibold rounded-xl shadow-sm ${dark ? 'auth-btn-primary' : 'bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 transition-colors duration-150'}`}
        >
          {isSubmitting
            ? <span className="flex items-center justify-center gap-2">
                <svg className="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                </svg>
                Sending…
              </span>
            : 'Send verification code'
          }
        </button>

        <p className="mt-5 text-center text-sm" style={dark ? { color: 'rgba(255,255,255,0.4)' } : { color: '#6b7280' }}>
          Remember your password?{' '}
          <Link to="/signin" className="font-medium" style={dark ? { color: 'rgba(147,197,253,0.9)' } : { color: '#2563eb' }}>Sign in</Link>
        </p>
      </form>
    </>
  );
};

export default ResetForm;
